import i18nMessages from 'dashboard/i18n';
import WindowVisibilityHelper from './AudioAlerts/WindowVisibilityHelper';

const DEFAULT_ICON = '/android-icon-192x192.png';

const localeMessages = () => {
  const raw = window.chatwootConfig?.selectedLocale || 'en';
  const locale = String(raw).replace('-', '_');
  return i18nMessages[locale] || i18nMessages.en;
};

const lookup = (messages, key) =>
  key.split('.').reduce((acc, part) => acc?.[part], messages);

export const translateDesktopNotification = (key, params = {}) => {
  const template =
    lookup(localeMessages(), key) || lookup(i18nMessages.en, key);
  if (typeof template !== 'string') return '';
  return template.replace(/\{(\w+)\}/g, (_, name) => params[name] ?? '');
};

export const unreadCountLabel = count => {
  const unread = Math.max(0, Number(count) || 0);
  if (unread <= 0) return '';
  if (unread === 1) {
    return translateDesktopNotification('DESKTOP_NOTIFICATION.UNREAD_ONE');
  }
  return translateDesktopNotification('DESKTOP_NOTIFICATION.UNREAD_MANY', {
    count: unread,
  });
};

export const canShowDesktopNotification = () => {
  if (typeof window === 'undefined' || !('Notification' in window)) {
    return false;
  }
  if (Notification.permission !== 'granted') return false;
  return !WindowVisibilityHelper.isWindowVisible();
};

export const showDesktopNotification = ({
  title,
  body,
  unreadCount,
  url,
  tag,
  icon = DEFAULT_ICON,
}) => {
  if (!canShowDesktopNotification()) return null;

  const unreadLabel = unreadCountLabel(unreadCount);
  const notificationBody = [body, unreadLabel].filter(Boolean).join('\n');

  const notification = new Notification(
    title || translateDesktopNotification('DESKTOP_NOTIFICATION.NEW_MESSAGE'),
    {
      body: notificationBody,
      tag: tag || 'dashboard-message',
      renotify: Boolean(tag),
      icon,
      badge: icon,
    }
  );

  notification.onclick = () => {
    notification.close();
    window.focus();
    if (url && window.location.href !== url) {
      window.location.assign(url);
    }
  };

  return notification;
};

export const conversationNotificationPreview = message => {
  if (message?.content) return message.content;
  const attachments = message?.attachments || [];
  if (attachments.some(item =>
    (item.content_type || '').startsWith('audio/')
  )) {
    return translateDesktopNotification('DESKTOP_NOTIFICATION.AUDIO_MESSAGE');
  }
  if (attachments.length) {
    return translateDesktopNotification('DESKTOP_NOTIFICATION.ATTACHMENT');
  }
  return translateDesktopNotification('DESKTOP_NOTIFICATION.FALLBACK_PREVIEW');
};
